import { useQuery } from "@tanstack/react-query";
import { fetchGetQuery } from "../api";

// API call to get project details for Splosno section
export function useGetAvtorizacije(upn) {
  const url = `Avtorizacije/upnV2/${upn}`;
  return useQuery({
    queryKey: ["avtorizacije", upn],
    queryFn: async () => {
      return fetchGetQuery(url);
    },
    enabled: !!upn, // Only run this query if upn is not empty
  });
}
